<template >
    <div class="container bg-white py-5 px-5" v-if="school && department && program && programYear">
      <h3>{{school.name}} / {{department.name}} / {{program.name}} </h3>
      <p>Чиглэл: {{programYear.name}}</p>
      <p>Зэрэг: {{programYear.degreeName}}</p>
      <p>Хугацаа: {{programYear.duration}}</p>
      <p v-if="programYear.startDay">
        Эхлэх хугацаа: 
        {{programYear.startDay.year}}-{{programYear.startDay.month}}- {{programYear.startDay.day}}
      </p>
      <p v-if="programYear.endDay">
        Дуусах хугацаа: 
        {{programYear.endDay.year}}-{{programYear.endDay.month}}- {{programYear.endDay.day}}
      </p>
      <p v-if="programYear.approvedDay">
        Баталсан хугацаа: 
        {{programYear.approvedDay.year}}-{{programYear.approvedDay.month}}- {{programYear.approvedDay.day}}
      </p>
      <p>Xичээлийн тоо: {{programYear.count}}</p>
      <p>Нийт кредит: {{programYear.totalCredit}}</p>
      <button type="button" class="btn btn-primary my-3" @click="_addProgram()">
        Төлөвлөгөөнд хичээл нэмэх
      </button>

      <!-- DataTales Example -->
      <div class="card shadow mb-4" >
        <div class="card-header py-3">
          <h6 class="m-0 font-weight-bold text-primary">Сургалтын төлөвлөгөөний хичээл</h6>
        </div>
        <div class="card-body" v-if="pros!=null && pros.length>0">
          <div class="table-responsive">
            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Хичээл</th>
                  <th>Улирал</th>
                  <th>Кредит</th>
                  <th>Төрөл</th>
                  <th>Үйлдэл</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(p, index) in pros" v-bind:key="p.id">
                  <td>{{index+1}}</td>
                  <td>
                    <div v-if="p.lesson">
                      {{p.lesson.name}} - {{p.lesson.lectureCode}}
                    </div>
                  </td>
                  <td>
                    {{p.season}}
                  </td>
                  <td>{{p.credit}}</td>
                  <td>
                    <div v-if="p.typeData">
                      {{p.typeData.name}}
                    </div>
                  </td>
            
                  <td>
                    <button class="btn btn-warning btn-sm" @click="_editProgram(p)">засах</button>
                    <!-- <button class="btn btn-danger btn-sm" @click="1">төлөвлөгөө</button> -->
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="alert alert-warning">Одоогоор мэдээлэл ороогүй байна.</div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="proModal" tabindex="-1" role="dialog" aria-labelledby="proModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="proModalLabel">Мэргэжлийн төлөвлөгөө нэмэх</h5>
              <p>{{school.name}} / {{department.name}} / {{program.name}} </p>
              <p>{{programYear.name}} - <span v-if="programYear.startDay">{{programYear.startDay.year}}</span></p>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="row">
                  <div class="col form-group">
                    <label for="exampleFormControlSelect1">Хичээл :</label>
                    <select class="form-control" disabled="true" v-model='pro.rootlesson' v-if="pro.id && pro.id!='' && pro.id!='new'">
                      <option v-for="type in rootlessons" v-bind:key="'rootlesson-'+type.id" v-bind:value="type.ref">{{type.name}}</option>
                    </select>
                    <select class="form-control"  v-model='pro.rootlesson' v-else>
                      <option v-for="type in rootlessons" v-bind:key="'rootlesson-'+type.id" v-bind:value="type.ref">{{type.name}}</option>
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="exampleFormControlSelect1">Улирал</label>
                  <select class="form-control" v-model='pro.season'>
                    <option v-for="month in seasons" v-bind:value="month">{{month}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>Кредит</label>
                  <input v-model.number="pro.credit" type="number" class="form-control" placeholder="Кредит">
                </div>
                <div class="row">
                  <div class="col form-group">
                    <label for="exampleFormControlSelect1">Хичээлийн төрөл:</label>
                    <select class="form-control" v-model='pro.type'>
                      <option v-for="type in degrees" v-bind:key="'type-'+type.id" v-bind:value="type.ref">{{type.name}}</option>
                    </select>
                  </div>
                </div>

                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
              <button @click="saveTopic" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Xадгалаx</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: "ProgramYearPlan",
    data() {
        return {
          school:null,
          department: null,
          program:null,
          programYear:null,
            pro:{
              season:null,
              credit:null,
              type:null
            },
            pros:[],
            degrees:[],
            seasons:[],
          rootlessons:[]

            
        };
    },
    methods: {
        
      _getQA(){
          fb.db.collection("lessontypes").orderBy("index").get().then(docs=>{
            this.degrees=[];
            docs.docs.forEach(value=>{
              let object=value.data();
              object.id=value.id;
              object.ref=value.ref;
              this.degrees.push(object);
            });
          });

          fb.db.collection("schools/"+this.schoolId+"/rootlessons").orderBy("createdAt").get().then(docs=>{
            this.rootlessons=[];
            docs.docs.forEach(value=>{
              let object=value.data();
              object.id=value.id;
              object.ref=value.ref;
              this.rootlessons.push(object);
            });
          });

          fb.db.doc("schools/"+this.schoolId).get().then(doc=> {
              let department=doc.data()
              department.id=doc.id
              this.school=department;
          });
          fb.db.collection("schools/"+this.schoolId+"/departments/").doc(this.departmentId).get().then(doc=> {
              let department=doc.data()
              department.id=doc.id
              this.department=department;
          });
          fb.db.collection("schools/"+this.schoolId+"/departments/"+this.departmentId+"/programs").doc(this.programId).get().then(doc=> {
              let department=doc.data()
              department.id=doc.id
              this.program=department;
          });
          fb.db.collection("schools/"+this.schoolId+"/departments/"+this.departmentId+"/programs")
            .doc(this.programId)
            .collection("programyears").doc(this.programYearId).onSnapshot(doc=> {
              let department=doc.data()
              department.id=doc.id
              this.programYear=department;
          });
          fb.db.collection("schools/"+this.schoolId+"/departments/"+this.departmentId+"/programs/"+this.programId+"/programyears").
          doc(this.programYearId).collection("lessonplan")
          .orderBy("createdAt","desc").onSnapshot(querySnapshot=> {
            this.pros=[];
            querySnapshot.forEach(doc=> {
              let object=doc.data();
              object.id = doc.id;
              object.lesson=null;
              object.typeData=null;
              if(object.rootlesson){
                object.rootlesson.get().then(ldoc=>{
                  if(ldoc){
                    object.lesson=ldoc.data();
                  }
                });
              }
              if(object.type){
                object.type.get().then(ldoc=>{
                  if(ldoc){
                    object.typeData=ldoc.data();
                  }
                });
              }
					    this.pros.push(object);
            });
            
          });

      },

      async saveTopic() {
          if(this.pro && this.pro.season && this.pro.credit && this.pro.type && this.pro.rootlesson){
            if(this.pro.rootlesson){
              var degreeDoc=await this.pro.rootlesson.get();
              if(degreeDoc){
                this.pro.rootLessonName=degreeDoc.data().name;
              }
            }
            if(this.pro.id!=null && this.pro.id!=''){
              this.pro.modifiedUser=fb.usersCollection.doc(this.$store.getters.currentUser.uid);
              this.pro.modifiedAt=new Date();  
              fb.db.collection("schools").doc(this.schoolId)
              .collection("departments").doc(this.departmentId)
              .collection("programs").doc(this.programId)
              .collection("programyears").doc(this.programYearId)
              .collection("lessonplan").doc(this.pro.id)
              .update(this.pro);
              
            }
            else{
              this.pro.createdAt=new Date();
              this.pro.userId=this.$store.getters.currentUser.uid;
              this.pro.user=fb.usersCollection.doc(this.$store.getters.currentUser.uid);

              fb.db.collection("schools").doc(this.schoolId)
              .collection("departments").doc(this.departmentId)
              .collection("programs").doc(this.programId)
              .collection("programyears").doc(this.programYearId)
              .collection("lessonplan").doc(this.pro.rootlesson.id)
              .set(this.pro);
              
            }
            this.calcTotal();
            this.pro={
              season:null,
              credit:null,
              type:null
            };
          }
      },
      async calcTotal(){
        var count=0;
        var sumCredit=0;
        var querySnapshot= await fb.db.collection("schools/"+this.schoolId+"/departments/"+this.departmentId+"/programs/"+this.programId+"/programyears").
          doc(this.programYearId).collection("lessonplan").get();

          querySnapshot.forEach(doc=> {
            if(doc && doc.exists && doc.data()){
              count++;
              if(doc.data().credit){
                sumCredit=doc.data().credit;
              }
            }
          });
        if(count>0){
          fb.db.collection("schools/"+this.schoolId+"/departments/"+this.departmentId+"/programs/"+this.programId+"/programyears").
          doc(this.programYearId).update({
            count: count,
            totalCredit: sumCredit 
          });
        }
            

      },
      _addProgram(){
          this.pro={
              season:null,
              credit:null,
              type:null
            };
          $('#proModal').modal('toggle');
      },
      _editProgram(pro){

          this.pro= Object.assign({}, pro);
          $('#proModal').modal('toggle');
      },
      _deleteProgram(pro){
          var result = confirm("Та "+pro.name+" хөтөлбөрийг устгах уу?");
          if (result) {
              fb.db.collection("schools").doc(this.schoolId).collection("departments").doc(this.departmentId).collection("programs").doc(pro.id).delete()
          }

      }

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        schoolId: { 
            required: true,
        },
        departmentId: { 
            required: true,
        },
        programId:{
          required:true
        },
        programYearId:{
          required:true
        }
    },
    created() {
        var _this=this;
        for(var i=1;i<=12;i++){
          this.seasons.push(i);
        }

        if(this.schoolId!=null && this.schoolId!='' && this.departmentId!=null && this.departmentId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).fromNow()
        }
        return '-'
      },
    
    }
  
};
</script>

<style scoped>
p {
    margin-top: 0;
    margin-bottom: 0rem;
}
</style>